import { TranslationKeys } from '~/common/types';

/**
 * Vehicle categories as the pricing API spells them. Anything outside this map is rendered as the
 * raw code rather than dropped.
 */
export const VEHICLE_CATEGORY_TRANSLATIONS: Record<
  string,
  keyof TranslationKeys
> = {
  'TO': 'vehicle_type.to',
  '4X4': 'vehicle_type.4x4',
  'CAM': 'vehicle_type.cam',
};
